import type { FaireProductEntity } from "../../entity_types/product";

export const p_ugnsq6men9: FaireProductEntity = {
  token: "p_ugnsq6men9",
  type: "product",
  name: "KD-TP1000 Kids Print Baby Doll Top - Light Camo",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/34feea68d6d6771b188a127f507138c2f38def4034d3531e2f48db7fc4de9770.jpeg",
  galleryImageUrls: [],
  priceDollars: 13.5,
  description: "This kids' baby doll top by Girlie Girl Originals features a light camo print and thoughtful detailing for a casual, youthful look. Ideal for pairing with shorts, it brings boutique charm to children's clothing collections.",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:51.085Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
